import { useState } from "react";
import useAuth from "../../src/hooks/useAuth";

function Profile() {
//   const [newPassword, setNewPassword] = useState("")
//   const [confirmPassword, setConfirmPassword] = useState("")
//   const [searchQuery, setSearchQuery] = useState("");
//   const [showResetPassword, setShowResetPassword] = useState<boolean>(false);

  const { user } = useAuth()
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-12">
      <div className="space-y-6">
        <div className="space-y-1">
            <h2 className="text-lg font-medium capitalize">{user?.name}</h2>
            <p className="text-gray-500">{user?.email}</p>
            <p className="text-blue-600 font-medium">{user?.adminType === "superAdmin"? "Super Admin":"Admin"}</p>
            <p className="text-gray-700"> {user?.permissions?.length! < 1 ? "Global" : "Federated"}</p>
        </div>

        {/* <div className="space-y-4 pt-4">
            <Button variant="link" onClick={() => setShowResetPassword(!showResetPassword)} className="bg-transparent text-orange-500 font-medium m-0 p-0">
                {!showResetPassword ? "Reset Password" : "Cancel"}
            </Button>

            {showResetPassword && <> <div className="space-y-2">
                <label htmlFor="new-password" className="text-gray-700 font-medium">
                    New Password
                </label>
                <Input
                    id="new-password"
                    type="password"
                    value={newPassword}
                    onChange={(e) => setNewPassword(e.target.value)}
                    className="bg-gray-200 border-l-4 border-blue-600"
                />
            </div>

                <div className="space-y-2">
                    <label htmlFor="confirm-password" className="text-gray-700 font-medium">
                        Confirm Password
                    </label>
                    <Input
                        id="confirm-password"
                        type="password"
                        value={confirmPassword}
                        onChange={(e) => setConfirmPassword(e.target.value)}
                        className="bg-gray-200 border-l-4 border-blue-600"
                    />
                </div>

                <Button className="bg-blue-600 hover:bg-blue-700 text-white w-full mt-4">Save</Button>
            </>}
        </div> */}
      </div>
      {/* <PermissionsSection /> */}
    </div>
  )
}

export default Profile